import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Website({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <Website.Outline {...props} />
  ) : (
    <Website.Solid {...props} />
  );
}

Website.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="1.5"
          className="icon-outline"
        />
        <path
          d="M2 12H22"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          className="icon-outline"
        />
        <path
          d="M12 2C14.5 4.5 16 8 16 12C16 16 14.5 19.5 12 22C9.5 19.5 8 16 8 12C8 8 9.5 4.5 12 2Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Website.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2" />
        <path
          d="M2 12H22"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12 2C14.5 4.5 16 8 16 12C16 16 14.5 19.5 12 22C9.5 19.5 8 16 8 12C8 8 9.5 4.5 12 2Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="currentColor"
          opacity="0.4"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
